'use client';

import { Box, Button } from '@mui/material';
import ProductComment from './ProductComment';
import { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const ProductReview = ({ reviews }) => {
  const [page, setPage] = useState(1);
  const numberPerPage = 3;
  return (
    <Box>
      <Box>
        {reviews.slice(0, numberPerPage * page).map((item, ind) => (
          <ProductComment {...item} key={ind} />
        ))}
      </Box>
      {numberPerPage * page < reviews.length && (
        <Button
          variant="text"
          size="large"
          fullWidth
          endIcon={<KeyboardArrowDownIcon />}
          onClick={() => setPage(page + 1)}
        >
          View More
        </Button>
      )}
    </Box>
  );
};
export default ProductReview;
